<app-signature-upload 
  [commission]="commission"
  [currentAccountId]="currentAccountId"
  [isReadDataFromSassEnabled]="isReadDataFromSassEnabled"
  [mode]="mode" 
  [selectedRule]="selectedRule"
  [signatures]="signatures" />
